import { render, staticRenderFns } from "./ConsumptionsPage.vue?vue&type=template&id=2b8b808f&"
import script from "./ConsumptionsPage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports